import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AdditionalShowType } from '../../../layout/toolbar/layout.toolbar';
import { useApiActions } from '../../../../../hooks/use-api-actions';
import { ApiGetTemplates } from '../../../../../api/sift/back/api-templates';
import { Env } from '../../../../../models/env';
import { store } from '../../../../../app/store';
import { dialogActions } from '../../../../dialog/slice/dialog-slice';
import iconTextCursor from '../../../../../assets/img/icon/text-cursor.svg';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { TrimUiManager } from '../../../../../trim-editor/manager/ui/trim.ui.manager';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';
import { AddAlbumParam, MenuType } from '../../../layout/layout';
import * as lodash from 'lodash';
import { TemplateLoaderManager } from '../../../../../layout-editor/manager/template-loader/template-loader.manager';
import { TrimPrint } from '../../../../../trim-editor/print/trim.print';
import { trimActions } from '../../../../../slices/trim-slice';
import { XmlParser } from '../../../../../manager/xml-parser';
import { TrimEditorManager } from '../../../../../trim-editor/manager/trim-editor.manager';
import { TrimTempModel } from '../../../../../trim-editor/model/trim.temp-model';
import { PrintTrimEditorToolBox } from './component/print-trim.editor.tool-box';
import { PrintTrimEditorToolTip } from './component/print-trim.editor.tool-tip';
import './print-trim.editor.scss'
import { PrintDataStructure } from '../../../../../models/sift/json/print-model';
import { PrintSelectImageData } from '../../print-select-images/hooks/use-print-select-images';
import { TrimEditableImage } from '../../../../../trim-editor/manager/image-edit/trim.editable-image';
import { ScreenColorType } from '../../../layout/menu/layout.menu';
import { UiManager } from '../../../../../layout-editor/manager/ui/ui.manager';
import { layoutActions } from '../../../../../slices/layout-slice';
import { useDispatch } from 'react-redux';
import { ErrorToast } from '../../../layout/edit-template/layout.edit-template';
import { PrintTrimMenuType } from '../hooks/use-print-trim';

type EditorContainerProps = {
  template: TrimTempModel | null,
  structure: PrintDataStructure | null,
  selectImage: TrimEditableImage | null,
  initMenu: PrintTrimMenuType;
  isRestore: boolean;
  callbackRestore: () => void;
}

const EditorContainer = (props: EditorContainerProps) => {
  const { template, structure, selectImage, initMenu, isRestore, callbackRestore } = props;
  const { kijshopCd, shopOrderId, orderId, imageId } = useParams<PathParams>();
  // - hooks -
  const dispatch = useAppDispatch();
  // - state -
  const [isRuler, setIsRuler] = useState(true);
  // - ref -
  const trimEditorContainer = useRef<HTMLDivElement>(null);
  const trimEditorManager = useRef<TrimEditorManager>();
  const isInit = useRef<boolean>(false);

  const grabbingCursor = useCallback(() => {
    trimEditorContainer.current!.style.cursor = 'grabbing';
  }, [trimEditorContainer.current]);
  const grabedCursor = useCallback(() => {
    trimEditorContainer.current!.style.cursor = 'grab';
  }, [trimEditorContainer.current]);

  /* templateXml取得処理 */
  const getTemplateXML = useCallback<any>(async (targetPath: string, templateName: string, pageType: string) => {
    const nextPathData = await TemplateLoaderManager.checkNextPath(targetPath, pageType);
    const data = await TemplateLoaderManager.ins.onGetTargetFile(nextPathData.path, 'templateXml', templateName);
    if (data) return data;
    // if (nextPath) return await getTemplateXML(nextPath, templateName, pageType);
    // if (nextPath) return await getTemplateXML(nextPath, 'templateXML', templateName);
    return undefined;
  }, []);


  // -- layoutEditorManager操作 --
  useEffect(() => {
    // if (!trimEditorContainer.current) return;
    TrimUiManager.ins.emit('t->r:wait-loading', { message: `画像読み込み中...` });

    const action = async () => {
      // await setAlbum();
      await new Promise<void>((resolve) => {
        const fontList = store.getState().trim.unfindFontList.map((v) => `・${v}`);
        if (fontList.length) {
          dispatch(dialogActions.pushMessage({
            title: 'フォント読み込みエラー',
            message: [
              'お使いのPCで見つからないフォントが使用されています。',
              '以下をデフォルトのフォントに置き換えてレイアウトを続けますか？',
              '',
              ...fontList,
            ],
            buttons: [
              {
                label: 'いいえ', callback: () => {
                  dispatch(dialogActions.pop());
                  // dispatch(push(preparationPath));
                },
              },
              {
                label: 'はい', callback: () => {
                  dispatch(dialogActions.pop());
                  dispatch(trimActions.pushUnFindFontList(null));
                  resolve();
                },
              },
            ],
          }));
        } else {
          resolve();
        }
      });
      dispatch(trimActions.setRestoreTemplates([]));
    };

    TrimUiManager.ins.on('r->t:ruler', (v) => {
      if (v.display) {
        setIsRuler(true);
      } else {
        setIsRuler(false);
      }
    });
    TrimUiManager.ins.on('r->t:change-operation-cursor', (v) => {
      if (!trimEditorContainer.current) return;
      if (v.mode === 'pan-zoom') {
        trimEditorContainer.current.style.cursor = 'grab';
        trimEditorContainer.current.addEventListener('mousedown', grabbingCursor);
        trimEditorContainer.current.addEventListener('mouseup', grabedCursor);
      } else if (v.mode === 'select') {
        trimEditorContainer.current.style.cursor = 'default';
        trimEditorContainer.current.removeEventListener('mousedown', grabbingCursor);
        trimEditorContainer.current.removeEventListener('mouseup', grabedCursor);
      } else {
        trimEditorContainer.current.style.cursor = `url(${iconTextCursor}) 13 13, text`;
      }
    });
    action();
    return () => {
      TrimUiManager.ins.off('r->t:ruler');
      TrimUiManager.ins.off('r->t:change-operation-cursor');
      if (trimEditorContainer.current) {
        trimEditorContainer.current.style.cursor = 'default';
        trimEditorContainer.current.removeEventListener('mousedown', grabbingCursor);
        trimEditorContainer.current.removeEventListener('mouseup', grabedCursor);
      }
      trimEditorManager.current?.destroy();
    };
  }, []);


  useEffect(() => {
    const activateEditor = async () => {
      if (!trimEditorContainer.current || !template || !structure || !selectImage) return;
      const item = structure.item?.[orderId];
      if (!item || isInit.current) return;
      isInit.current = true;
      TrimUiManager.ins.emit('t->r:wait-loading', { message: '編集情報を読み込んでいます…' });
      console.log(template);
      const editor = new TrimEditorManager(trimEditorContainer.current);
      trimEditorManager.current = editor;
      editor.initialize();
      console.log(selectImage);
      await editor.manager.trimPrint.create({temp: template, kijshopCd, shopOrderId, orderId, editableImgId: imageId, item, structure});
      console.log(structure);
      console.log(initMenu);
      await editor.manager.imageEdit.initStage({kijshopCd, shopOrderId, orderId, initMenu});
      await editor.manager.imageEdit.activateStage(kijshopCd, shopOrderId, orderId, initMenu);
      TrimUiManager.ins.emit('t->r:wait-loading', { message: '' });
    }

    activateEditor()
  }, [trimEditorContainer.current, template, structure, selectImage]);

  return (
    <div
      className={`editor_container${isRuler ? '' : ' close'}`}
    >
      <div
        className="editor_container__inner"
        ref={trimEditorContainer}
      >
        <div className="editor_container__ruler_origin" />
      </div>
    </div>
  );
};

const PrintTrimEditor = (props: EditorContainerProps) => {
  const { template, structure, selectImage, initMenu, isRestore, callbackRestore } = props;
  const dispatch = useDispatch();
  const [toast, setToast] = useState(false);

  useEffect(() => {
    const handlerRightClick = (e: MouseEvent) => {
      e.preventDefault();
    };
    TrimUiManager.ins.on('t->r:show-toast', (v) => {
      setToast(v.isToast);
      if (v.isToast) {
        dispatch(layoutActions.setFitErrorList(v.target.pageId || ''));
      } else {
        if (v.target.name !== 'stage-container') {
          dispatch(layoutActions.removeFitErrorList(v.target.pageId || ''));
        }
      }
    });
    window.addEventListener('contextmenu', handlerRightClick);
    return () => {
      TrimUiManager.ins.off('t->r:show-toast');
      window.removeEventListener('contextmenu', handlerRightClick);
    };
  }, []);

  return (
    <div
      className="trim_editor"
      // onContextMenu={handlerRightClick}
    >
      <EditorContainer
        template={template}
        structure={structure}
        selectImage={selectImage}
        initMenu={initMenu}
        isRestore={isRestore}

        callbackRestore={callbackRestore}
      />
      {/*<PrintTrimEditorToolBox />*/}
      <PrintTrimEditorToolTip />
      {/*<ImageInfo />*/}
      <ErrorToast
        text={['写真枠内に空白部分があります。']}
        className={toast ? 'enter' : 'leave'}
      />
    </div>
  );
};

export default PrintTrimEditor;
